<template>
    <div>
        <!-- Modal Evoluções -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Prescrições</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="form-row mb-3">
                            <div class="col col-12">
                                <az-periodo
                                    :sync="true" 
                                    @sync="load()"
                                    v-model="filtro" />
                            </div>

                            <div class="col col-12 col-md-4" v-if="false">
                                <az-input
                                    icon="fa-solid fa-magnifying-glass"
                                    placeholder="Pesquisar..."
                                    v-model="filtro.search" />
                            </div>
                        </div>

                        <az-empty-state 
                            v-if="!dados || !dados.lista || !dados.lista.length" 
                            message="Nenhuma prescrição encontrada para o período selecionado." />

                        <template v-else>

                            <div class="d-flex justify-content-end">
                                <button type="button" class="btn btn-link" @click="toggle_hide_all()">
                                    <i class="fas fa-compress-arrows-alt"></i>
                                </button>
                            </div>

                            <order-set-view
                                :dados="dados.lista"
                                type="receita" 
                                :view_only="true" /> 
                        
                        </template>
                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import _ from 'lodash'; 
import $ from 'jquery';
import * as moment from "moment";
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import OrderSetView from '../consultorio/OrderSetView.vue';

export default {
    data() {
        return {
            dados: null, 
            data_filtro: null, 
            id_internacao: null,
            dt_inicio: null,
            dt_fim: null,
            filtro: {
                periodo: "", 
                inicio: null,
                fim: null, 
                search: "", 
            },
            validate: false, 
        };
    },

    components: { 
        AzPeriodo, 
        AzEmptyState,
        AzInput,
        OrderSetView,
    },
  
    computed: { 
        modal_name: function() {
            return 'presc_modal_' + this.chave;
        }
    },

    methods: { 
        toggle_hide_all() {
            let lista = this.dados.lista;

            let acao = lista.find(item => item && !item.hide) ? true : false;

            lista.forEach(item => {
                if ( item ) {
                    item.hide = acao;
                }
            });

            this.$forceUpdate();
        },
        
        getHumanDuration(date) {
            if (date.substr(0, 10) == this.$util.hoje()) return "hoje";
            else
                {
                moment.relativeTimeRounding(Math.floor);
                return moment
                    .duration(moment(date, "YYYY-MM-DD").diff(this.$util.hoje()))
                    .humanize(true);
                } 
        },

        fechar_modal() {
            $('#' + this.modal_name).modal('hide');
        },

        titulo_registro(registro, show_modelo = false, block_proc = false) { 
            return ( ( !block_proc && registro.procedimento ) ? registro.procedimento.search + ': ' : '' ) 
                + ( show_modelo ? ( registro.modelo.st_modelo_prontuario + ' - ' ) : '' )
                + _.get(registro, 'usuario.pessoa.st_nome') + ', ' 
                + ( !registro.created_at 
                    ? 'Novo' 
                    : ( this.$util.getFormatDate(registro.created_at) + ' ' + registro.created_at.substr(11,5) ) )
        },

        init () { 
            this.lista_registros_datas = []; 

            this.lista_registros_calc_data = _.groupBy(
                _.orderBy(
                    this.lista.registros.filter(registro => registro.fl_ativo && registro.id_atendimento_registro),
                    'created_at',
                    'desc'
                ), 
                item => { 
                    console.log('item', item);
                    return item ? item.created_at.slice(0,10) : '-';
                }
            );

            _.each(this.lista_registros_calc_data, (item, data) => { 
                this.$set(this.lista_registros_datas, data, false);
            });
        },

        abrir(id_internacao, dt_inicio, dt_fim) { 

            this.lista_registros_calc_data = null; 
            this.id_internacao = id_internacao;
            this.dt_inicio = dt_inicio;
            this.dt_fim = dt_fim;

            this.filtro.inicio = this.dt_inicio;
            this.filtro.fim = this.dt_fim;

            $('#' + this.modal_name).modal('show');

            this.load(); 

        },

        load() { 
            
            this.$util.load(this, { 
                service: 'enfermagem',
                func: 'prescricoes',
                parms: { 
                    id_internacao: this.id_internacao,
                    ...this.filtro, 
                },
                loadTo: res => { 
                    this.dados = res;
                    this.init();
                }
            });

        }
    },

    mounted() { 
        this.chave = this.$util.uuidv4(); 
    }

}
</script>
